export default "__VITE_ASSET__BIuHZNA3__"